import { Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CardSkeleton } from './CardSkeleton';

interface UsersCardProps {
  totalUsers: number;
  isLoading?: boolean;
}

export const UsersCard: React.FC<UsersCardProps> = ({ totalUsers, isLoading }) => {
  const { t } = useTranslation('dashboard');

  if (isLoading) {
    return <CardSkeleton />;
  }

  return (
    <div className="bg-card p-6 rounded-lg border shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium">{t('cards.users.title')}</h3>
        <Users className="w-5 h-5 text-muted-foreground" />
      </div>
      <div className="text-2xl font-bold mb-2">{totalUsers}</div>
      <div className="text-sm text-muted-foreground">{t('cards.users.description')}</div>
    </div>
  );
};
